exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submit-btn[data-v-01c79436]{background:#5587d7;color:#fff;float:right;padding:5px 15px;margin:7px;border-radius:3px;position:relative;bottom:42px;display:inline-block;margin-bottom:-35px}.float-right[data-v-01c79436]{float:right}.btn[data-v-01c79436]{background:rgba(36,121,255,.25);border-radius:3px;color:#f5f5f5;font-size:14px;width:88px;margin-top:5px;margin-bottom:5px;padding:5px}.primary-btn[data-v-01c79436]{background:#2479ff}.warning-btn[data-v-01c79436]{background:#e0a800;color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-01c79436","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/CommentForm.vue
// module id = SNPj
// module chunks = 0